module.exports = __webpack_public_path__ + "img/clock.dd314c26.svg";